import { httpRequest } from 'http'
import { sendErrorNotification } from 'helpers/web_to_client'

export const USER_FLAGS_SUBMIT_REQUEST = 'user_flags/SUBMIT_REQUEST'
export const USER_FLAGS_SUBMIT_SUCCESS = 'user_flags/SUBMIT_SUCCESS'
export const USER_FLAGS_SUBMIT_ERROR = 'user_flags/SUBMIT_ERROR'

export function submitFlagRequest() {
    return {
        type: USER_FLAGS_SUBMIT_REQUEST,
        payload: {},
    }
}

export function submitFlagSuccess(resp) {
    const { flags } = resp
    return {
        type: USER_FLAGS_SUBMIT_SUCCESS,
        payload: { flags },
    }
}

export function submitFlagError(errorData) {
    sendErrorNotification(errorData)
    return {
        type: USER_FLAGS_SUBMIT_ERROR,
        payload: errorData,
    }
}

export default function submitUserFlag(flag) {
    return async (dispatch, getState) => {
        if (getState().userFlags.submitting) {
            return
        }
        dispatch(submitFlagRequest())
        httpRequest('/game_api/account_info', 'PATCH', { flag }).then(
            resp => dispatch(submitFlagSuccess(resp)),
            errorData => dispatch(submitFlagError(errorData))
        )
    }
}



// WEBPACK FOOTER //
// ./state/actions/user_flags.js